import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gdih_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      const path = window.location.pathname;
      const inAdmin = path.startsWith("/admin") && path !== "/admin/login";
      const inPortal = path.startsWith("/portal");
      if (inAdmin || inPortal) {
        localStorage.removeItem("gdih_token");
        window.location.href = "/admin/login?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
